__turbopack_context__.v({
  "brand": "GehBAG_brand",
  "content": "GehBAG_content",
  "footer": "GehBAG_footer",
  "footerLinks": "GehBAG_footerLinks",
  "page": "GehBAG_page",
  "shell": "GehBAG_shell",
  "themeToggle": "GehBAG_themeToggle",
});
